module.exports = [{
      plugin: require('D:/Sources/studia-translatorica/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
